<template>
  <div>
    <keep-alive>
      <router-view></router-view>
    </keep-alive>
    <van-tabbar
      class="bottom-nav"
      v-model="active"
      active-color="#7469f8"
      inactive-color="#999999"
      route
    >
      <van-tabbar-item
        v-for="(item, index) in tabProps"
        :key="index"
        replace
        :to="item.route"
      >
        <span>{{ item.label }}</span>
        <template #icon="props">
          <iconpark-icon
            :color="props.active ? '#7469f8' : '#999999'"
            class="svg-icon"
            :name="item.icon"
          ></iconpark-icon>
        </template>
      </van-tabbar-item>
    </van-tabbar>
  </div>
</template>

<script>
export default {
  name: "QzTabbar",
  props: {
    tabProps: {
      type: Array,
      required: true,
      default: () => []
    }
  },
  data() {
    return {
      active: 0
    };
  }
};
</script>
<style lang="less" scoped>
/deep/.van-tabbar{
  background-color: #F2F2F4;
  height: 70px;
}
</style>



// WEBPACK FOOTER //
// src/components/common/QzTabbar/index.vue